<nimbus-menu-item [entry]="entry" [overlayContent]="(isSplitScreenEnabled$ | async) ? companionPanel : null"></nimbus-menu-item>

<ng-template #companionPanel>
  <div class="menu-multiple-item-overlay-callout"></div>
  <ul>
    <li>
      <div
        id="menu-companion-full-screen"
        class="flex-container flex-align-center-left menu-overlay-item"
        (mousedown)="navigateFullScreen()"
      >
        <i [nimbusIcon]="ICONS.COMPANION"></i>
        <span>{{ TranslationKeys.CompanionChatFullScreen | icuTranslate }}</span>
      </div>
    </li>
    <li>
      <div
        id="menu-companion-split-screen"
        class="flex-container flex-align-center-left menu-overlay-item"
        (mousedown)="navigateSplitScreen()"
      >
        <i [nimbusIcon]="ICONS.COLUMNS"></i>
        <span>{{ TranslationKeys.CompanionChatSplitScreen | icuTranslate }}</span>
      </div>
    </li>
  </ul>
</ng-template>
